import { API } from './instances'

export const contact = params => {
    const url = '/Contacto'
    return API.post(url, params)
}
